module.exports = __WEBPACK_EXTERNAL_MODULE_55__;


//////////////////
// WEBPACK FOOTER
// external "bannerWpStrings"
// module id = 55
// module chunks = 0